import { useEffect } from "react";

/**
 * Injects a temporary <meta name="robots" content="noindex,nofollow">
 * on mount and removes it on unmount. Used on admin pages so search
 * engines never include them in results, even if discovered.
 */
export function useNoIndex() {
    useEffect(() => {
        const tag = document.createElement("meta");
        tag.name = "robots";
        tag.content = "noindex, nofollow, noarchive";
        document.head.appendChild(tag);
        return () => {
            document.head.removeChild(tag);
        };
    }, []);
}
